import React, { useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from 'react-router-dom';

const Header = () => {
  
    const history = useHistory();
    const location = useLocation();

    const setEventListener = useCallback(async () => {  
        window.addEventListener('message', (e)=>{
            // Tronlink chrome v3.22.0 & Tronlink APP v4.3.4 started to support 
            if (e.data.message && e.data.message.action === "accountsChanged") {
                history.push('/');
            }
            
            // Tronlink chrome v3.22.0 & Tronlink APP v4.3.4 started to support  
            if (e.data.message && e.data.message.action === "connectWeb") {
                console.log("connectWeb event", e.data.message)
                console.log("current address:", e.data.message.data.address)
            }

            if (e.data.message && e.data.message.action === "setNode") {
                let nodeUrl = e.data.message.data.node.fullNode;

                if(process.env.REACT_APP_MODE === 'dev'){
                    if (nodeUrl === 'https://api.nileex.io'){
                        console.log("tronLink currently selected the test chain")
                    }else{
                        alert(`Available only on the tron Nile-testnet.\nThe node connected now is '${nodeUrl}'.`);
                        history.push('/');
                    }
                }else{
                    if (nodeUrl === 'https://api.trongrid.io' || nodeUrl === 'https://api.tronstack.io'){
                        console.log("tronLink currently selected the main chain")
                    }else{
                        alert(`Available only on the tron mainnet.\nThe node connected now is '${nodeUrl}'.`);
                        history.push('/');
                    }
                }
            }
        });  
    }, [history]);

    useEffect(() => {
        setEventListener();
    }, [setEventListener])
   
    function goHome(){
        history.push('/');
    }

    return(
        <div id="header">            
            {
                location.pathname === '/'
                ?
                null
                :
               
                <span className={`title ${process.env.REACT_APP_MODE === 'dev' ? "dev" : ""}`}  onClick={goHome}>
                    CRETA
                </span>
              
            }
        </div>
    )
}

export default Header;